const loaderStyle = (theme) => ({
  loaderContainer: {
    //backgroundColor: "#fff",
    //boxShadow: "0px 6px 58px rgba(121, 145, 173, 0.195504)",
    borderRadius: '24px',
    width: '150px',
    height: '150px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  loaderDesc: {
    color: '#000',
    fontSize: '14px',
    lineHeight: '24px', // theme.typography.lineHeight....
    position: 'absolute',
    bottom: '10px'
  },
  spinner: {
    //  backgroundColor :"#00ADE7",
    height: '50px',
    width: '50px',
    //border: "2px solid rgba(125, 133, 146, 0.202032)",
    border: '5px solid transparent',
    borderRadius: '50%',
    // borderRight: "2px solid #00ADE7",
    // borderBottom: "2px solid #00ADE7",
    borderRight: '5px solid #fff',
    borderBottom: '5px solid #fff',
    borderTop: '5px solid #fff',
    '@media (prefers-reduced-motion: no-preference)': {
      animation: '$spinner 1s linear  infinite '
    }
  },
  '@keyframes spinner': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  }
});

export default loaderStyle;
